export default "__VITE_ASSET__DhROTqL$__"